/**
 * @ngdoc filters
 * @memberof mercury.filters
 * @name avgof
 */
angular.module('mercury.filters.avgof', [])
.filter('avgof', function() {
  return function(dataArray, key) {
    var value = 0;
    angular.forEach(dataArray, function(dataObj) {
      var dataPoint = dataObj[key];
      if (dataPoint) {
        value += dataPoint;
      }
    });
    return !angular.isArray(dataArray) || dataArray.length === 0 ? 0 : value / dataArray.length;
  };
});
